// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__6m0ed {
  position: relative;
  padding: 64px 0;
  background-color: #0b1d3a;
}
@media (min-width: 900px) {
  .Footer_footer__6m0ed {
    padding: 80px 0;
  }
}
.Footer_footer__6m0ed::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, #c9a84c 50%, transparent 100%);
  opacity: 0.3;
}

.Footer_footer__container__-YNDH {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 32px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
@media (min-width: 900px) {
  .Footer_footer__container__-YNDH {
    gap: 48px;
  }
}

.Footer_footer__brand__FL3ZX {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (min-width: 900px) {
  .Footer_footer__brand__FL3ZX {
    flex: 0 0 280px;
  }
}

.Footer_footer__logo__xKyDT {
  width: 100px;
  aspect-ratio: 754/439;
  object-fit: contain;
  cursor: pointer;
}

.Footer_footer__tagline__2rvPb {
  max-width: 260px;
  font-family: "Source Sans 3", sans-serif;
  font-size: 0.88rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.45);
}

.Footer_footer__nav__QuLk\\+ {
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (min-width: 600px) {
  .Footer_footer__nav__QuLk\\+ {
    flex: 0 0 auto;
  }
}

.Footer_footer__nav-title__rqzSV {
  margin: 0 0 4px;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.3);
}

.Footer_footer__nav-list__XKUIx {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.Footer_footer__link__p\\+pYv {
  font-family: "Source Sans 3", sans-serif;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  transition: color 0.2s;
}
.Footer_footer__link__p\\+pYv:hover {
  color: #c9a84c;
}

.Footer_footer__bottom__GIXHp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  max-width: 1280px;
  margin: 40px auto 0;
  padding: 24px 24px 0;
  border-top: 1px solid rgba(201, 168, 76, 0.1);
}
@media (min-width: 600px) {
  .Footer_footer__bottom__GIXHp {
    flex-direction: row;
    align-items: center;
  }
}

.Footer_footer__copyright__lImLF {
  margin: 0;
  font-family: "Source Sans 3", sans-serif;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.3);
}

.Footer_footer__region__JvkZO {
  margin: 0;
  font-family: "Source Sans 3", sans-serif;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/LandingPage/Layout/Footer/Footer.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;AACF;AACE;EALF;IAMI,eAAA;EAEF;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iFAAA;EAMA,YAAA;AAJJ;;AAQA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AALF;AAOE;EATF;IAUI,SAAA;EAJF;AACF;;AAOA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;AAME;EANF;IAOI,eAAA;EAHF;AACF;;AAMA;EACE,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;AAKE;EANF;IAOI,cAAA;EAFF;AACF;;AAKA;EACE,eAAA;EACA,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6CAAA;AAHF;AAKE;EAXF;IAYI,mBAAA;IACA,mBAAA;EAFF;AACF;;AAKA;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,+BAAA;AAFF;;AAKA;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,+BAAA;AAFF","sourcesContent":[".footer {\n  position: relative;\n  padding: 64px 0;\n  background-color: #0b1d3a;\n\n  @media (min-width: 900px) {\n    padding: 80px 0;\n  }\n\n  // Top gold divider\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(\n      90deg,\n      transparent 0%,\n      #c9a84c 50%,\n      transparent 100%\n    );\n    opacity: 0.3;\n  }\n}\n\n.footer__container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 32px;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 24px;\n\n  @media (min-width: 900px) {\n    gap: 48px;\n  }\n}\n\n.footer__brand {\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  @media (min-width: 900px) {\n    flex: 0 0 280px;\n  }\n}\n\n.footer__logo {\n  width: 100px;\n  aspect-ratio: 754 / 439;\n  object-fit: contain;\n  cursor: pointer;\n}\n\n.footer__tagline {\n  max-width: 260px;\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: 0.88rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.footer__nav {\n  flex: 1 1 45%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  @media (min-width: 600px) {\n    flex: 0 0 auto;\n  }\n}\n\n.footer__nav-title {\n  margin: 0 0 4px;\n  font-family: \"Source Sans 3\", sans-serif;\n  font-weight: 600;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.footer__nav-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.footer__link {\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.55);\n  text-decoration: none;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #c9a84c;\n  }\n}\n\n.footer__bottom {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n  max-width: 1280px;\n  margin: 40px auto 0;\n  padding: 24px 24px 0;\n  border-top: 1px solid rgba(201, 168, 76, 0.1);\n\n  @media (min-width: 600px) {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n.footer__copyright {\n  margin: 0;\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.footer__region {\n  margin: 0;\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__6m0ed`,
	"footer__container": `Footer_footer__container__-YNDH`,
	"footer__brand": `Footer_footer__brand__FL3ZX`,
	"footer__logo": `Footer_footer__logo__xKyDT`,
	"footer__tagline": `Footer_footer__tagline__2rvPb`,
	"footer__nav": `Footer_footer__nav__QuLk+`,
	"footer__nav-title": `Footer_footer__nav-title__rqzSV`,
	"footer__nav-list": `Footer_footer__nav-list__XKUIx`,
	"footer__link": `Footer_footer__link__p+pYv`,
	"footer__bottom": `Footer_footer__bottom__GIXHp`,
	"footer__copyright": `Footer_footer__copyright__lImLF`,
	"footer__region": `Footer_footer__region__JvkZO`
};
export default ___CSS_LOADER_EXPORT___;
